import { render, staticRenderFns } from "./businessVisitor.vue?vue&type=template&id=4ab1659c&scoped=true"
import script from "./businessVisitor.vue?vue&type=script&lang=js"
export * from "./businessVisitor.vue?vue&type=script&lang=js"
import style0 from "./businessVisitor.vue?vue&type=style&index=0&id=4ab1659c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab1659c",
  null
  
)

export default component.exports